import { useLocalStoreData, useCrudAction } from 'stores/hooks';
import {
  createDocumentAsync,
  deleteDocumentAsync,
  getCreateDocumentRequestStatus,
  getDeleteDocumentRequestStatus,
  getDocumentsListRequestStatus,
  getDocumentsList,
  getDocumentsAsync,
} from './documentsSlice';

export function useCreateDocument() {
  return useCrudAction({
    thunk: createDocumentAsync,
    requestStatusGetter: getCreateDocumentRequestStatus,
  });
}

export function useDeleteDocument() {
  return useCrudAction({
    thunk: deleteDocumentAsync,
    requestStatusGetter: getDeleteDocumentRequestStatus,
  });
}

export function useDocumentList(params?: URLSearchParams) {
  return useLocalStoreData({
    dataGetter: getDocumentsList,
    requestStatusGetter: getDocumentsListRequestStatus,
    thunk: getDocumentsAsync,
    params,
  });
}
